
      window.__ospBoot = function () {
        return import('/src/main.ts');
      };
    